import { TableCell, TableRow } from '@/components/ui'
import type { CreditBankEntry } from '@/modules/account/types'
import { cn, formatDate } from '@/utils'
import { amountClass, describeReason, formatDelta } from '../labels'

export const ChildRow = ({ entry }: { entry: CreditBankEntry }) => (
  <TableRow className="bg-muted/30">
    <TableCell className="w-8" />
    <TableCell className="text-muted-foreground whitespace-nowrap text-xs tabular-nums">
      {formatDate(entry.createdAt, 'h:mm a')}
    </TableCell>
    <TableCell className="pl-8 text-sm">
      {entry.source?.label ?? describeReason(entry.reason)}
    </TableCell>
    <TableCell className={cn(amountClass(entry.deltaCredits), 'text-sm')}>
      {formatDelta(entry.deltaCredits)}
    </TableCell>
    <TableCell className="text-muted-foreground">—</TableCell>
  </TableRow>
)
